
import { activationService } from '@/services/auth'
import { defineComponent } from 'vue'
import decode from 'jwt-decode'
import ActionButton from '@/components/ActionButton.vue'

export default defineComponent({
  data () {
    return {
      activationEmail: '',
      isActivating: false
    }
  },
  components: {
    ActionButton
  },
  mounted () {
    try {
      this.activationEmail = decode(this.$route.params.hash)
    } catch (error) {
      this.setLayoutAlertText(error.message)
    }
  },
  inject: ['setLayoutAlertText'],
  methods: {
    async handleActivate () {
      this.isActivating = true
      const res = await activationService(this.$route.params.hash)
      if (!res.error) {
        this.setLayoutAlertText(res.message)
        this.$router.push({ name: 'login', params: { email: this.activationEmail.email } })
      }
    }
  }
})
